import escape from './escape';

export default escape;
